import { Component, HostListener, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AgentService } from '../agent/agent.service';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { map } from 'rxjs/operators';
import { Observable , isObservable} from 'rxjs';
import { DatePipe } from '@angular/common';
// import supportCities from "../../../assets/data/supportedCities.json"
import postalCode from "../../../assets/data/postalCode.json";
import { Router } from '@angular/router';
import { ModalComponent } from './modal/modal.component';
import { LeadWebsocketService } from './lead-websocket.service';
@Component({
  selector: 'app-editlead',
  templateUrl: './editlead.component.html',
  styleUrls: ['./editlead.component.scss'],
})
export class EditleadComponent implements OnInit {
  minutes: number = 0;
  seconds: number = 0;
  private intervalId: any;
  private UIstartTime: number;
  startTime: Date;
  duration: number; // Duration in milliseconds
  agentHistory: any;
  lead: any;
  leadForm: FormGroup;
  form$: Observable<FormGroup>;
  filteredCities: any[] = [];
  supportedCities: any[] = [];
  selectedIndex: number;
  isAddingProduct: boolean = false;
  initialRowCount: number = 4;
  showAllRows: boolean = false;
  skusList:any[]=[];
  isSubmitting: boolean = false;
  showConfirmation = false; // Add this variable to control popup visibility
  selectedStatus: any;
  locations: any;
  totalCalls : number;
  isCalling = false;
  isFormLoaded = false;
  leadReferenceFromUrl: string;
  isHistoryModalOpen = false;
  leadHistory: any[] = [];
  newStatus: boolean = false; 
  private countryCodeMap: { [key: string]: string } = {
    Tunisia: 'TN',
    Senegal: 'SN',
    'Ivory-Coast': 'CI',
    Morocco: 'MA',
  };
  toggleRowCount(): void {
    this.showAllRows = !this.showAllRows;
  }
  
  getDisplayedConfirmationHistory(): any[] {
    return this.showAllRows ? this.lead?.confirmationHistory : this.lead?.confirmationHistory?.slice(0, this.initialRowCount);
  }

  removeProductConfirmation(index: number): void {
    this.showConfirmation = true; // Show the delete confirmation popup
    // Store the selected index for confirmation
    this.selectedIndex = index;
  }

  onDeleteConfirmation(confirm: boolean): void {
    if (confirm) {
      // If confirmed, remove the product
      this.productsFormArray.removeAt(this.selectedIndex);
    }
    // Close the delete confirmation popup
    this.showConfirmation = false;
  }

  dropdownListStatus: string[] = ["NEW", "CONFIRMED", "RECONFIRMED", "CANCELED", "NOANSWER", "SCHEDULED", "UPSELL", "WRONGNUMBER", "EXCEPTION", "DUPLICATED"];
  dropdownListConfirmType: string[] = ["CONFIRM", "RECONFIRM", "NONE"];
  cancellationReasons: string[] = [
    "Non intérêt pour le produit : le prospect n'a pas besoin ou ne souhaite pas acquérir ce que vous proposez.",
    "Budget insuffisant : (prix trop cher) : le prospect n'a pas les moyens financiers nécessaires pour effectuer un achat.",
    "Décision reportée : le prospect n'est pas prêt à prendre une décision immédiate et préfère y réfléchir.",
    "Contact déjà existant avec un concurrent",
    "Fausse commande",
    "Client non sérieux",
    "Réclamation client"
  ];  
  showCancellationReasons: boolean = false;
  scheduledDeliveryDate: string;

  constructor(
    private agentService: AgentService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private datePipe : DatePipe,
    private router: Router,
    private modal: ModalComponent ,// Inject the ModalComponent here
    private http: HttpClient,
    public leadSocket: LeadWebsocketService
  ) {

    this.agentHistory = {
      idLead: '',          // Static idLead for testing
      actionStatus: '',    // Static action status
      duration: 0 ,        // Will be calculated later
      // fbleadreference : ''
    };
   }

   openHistoryModal() {
    if (!this.lead?.primaryPhoneNumber) return console.error("Phone number is missing!");
  
    this.agentService.searchLeadByPhoneNumber(this.lead.primaryPhoneNumber).subscribe({
      next: (response) => {
        this.leadHistory = response || [];
        this.isHistoryModalOpen = true;
      },
      error: (err) => console.error("Error fetching lead history:", err)
    });
  }
  
  

  closeHistoryModal() {
    this.isHistoryModalOpen = false;
  }

   ngOnInit(): void {
    this.leadSocket.connect();
    this.leadReferenceFromUrl = this.route.snapshot.queryParamMap.get('leadreference') || '';
    console.log ("the reference used is ", this.leadReferenceFromUrl)
    this.startTime = new Date();
  
    console.log('Supported Cities in EditleadComponent:', this.supportedCities);
  
    this.route.queryParams.subscribe(params => {
      const leadReference = params['leadreference'] || params['leadReference'];
      console.log("Reference:", leadReference);
  
      if (leadReference) {
        this.agentService.loadLeadDetails(leadReference);
      }
    });
      // Delay the selected countries check
      const selectedCountries = JSON.parse(sessionStorage.getItem('selectedCountries') || '[]');
      if (selectedCountries.length > 0) {
        this.fetchLocations(selectedCountries); // Pass the selected countries dynamically
      } else {
        console.warn('No countries found in session storage.');
      }
    this.agentService.jsonData$.subscribe((data) => {
      this.lead = data;
      console.log("Lead Data:", this.lead);
      console.log("skus list", this.lead?.skus);
      this.skusList = this.lead?.skus;
      // Prioritize initialization logic
      if (this.lead) {
        this.initializeForm();
        this.updateStatusBasedOnBackendValue();
        this.isFormLoaded = true;
      }
      // Defer non-critical logic
      setTimeout(() => {
        console.log("Lead ID:", this.lead?.id);
        console.log("FBLeadReference", this.lead?.fbLeadReference);
        console.log("province", this.lead?.province);
        console.log('Scheduled Delivery Date:', this.lead?.scheduledDeliveryDate);
        this.scheduledDeliveryDate = this.extractDate(this.lead?.scheduledDeliveryDate);
  
        // Check if confirmationHistory is defined before accessing length
        // console.log("the confirmation hisotry for the total",this.lead?.confirmationHistory);
        // let confirmationHistoryCount = this.lead?.confirmationHistory?.length || 0;
        // this.totalCalls = confirmationHistoryCount === 0 ? 0 : confirmationHistoryCount - 1; 
        let confirmationHistoryCount = this.lead?.confirmationHistory?.length || 0;
        // Check if any object in confirmationHistory has `callCenterLeadStatus` as "PENDING_CONFIRMATION"
        const hasPendingConfirmation = this.lead?.confirmationHistory?.some(
          (history: any) => history.callCenterLeadStatus === "PENDING_CONFIRMATION"
        );
        // Adjust `totalCalls` based on the presence of "PENDING_CONFIRMATION"
        this.totalCalls = hasPendingConfirmation
          ? confirmationHistoryCount - 1
          : confirmationHistoryCount;
      }, 0); // Delay the execution to prioritize critical logic
    });
  
    // Start the timer
    this.UIstartTime = Date.now();
    this.intervalId = setInterval(() => {
      const currentTime = Date.now();
      const totalSeconds = Math.floor((currentTime - this.UIstartTime) / 1000);
  
      // Calculate minutes and seconds
      this.minutes = Math.floor(totalSeconds / 60);
      this.seconds = totalSeconds % 60;
    }, 1000);
    this.isNewStatus();
  }
  

  // onDialCall() {
  //   this.isCalling = true;
  //   const phoneNumber = this.lead?.primaryPhoneNumber || 'Unknown number';
  //   alert(`Calling ${phoneNumber}...`);
  // }

  onDialCall() {
    this.isCalling = true;
    const phoneNumber = this.lead?.primaryPhoneNumber;
  
    // Check if agentId and phoneNumber are both valid (non-null, non-empty)
    const id_agent = this.agentService?.getAgentIdAppareil();
    if (id_agent && phoneNumber) {
      this.agentService.sendCallDataByAgent(id_agent, phoneNumber).subscribe({
        next: (response) => {
          console.log('Success:', response);
          alert(`Call successfully initiated: ${response.message}`);
        },
        error: (error) => {
          console.error('Error:', error);
          alert('Failed to initiate the call. Please try again later.');
        },
      });
    } else {
      alert('Agent ID and Phone Number are required');
    }
  
    // alert(`Calling ${phoneNumber}...`);
  }
  
  

  // onEndCall() {
  //   this.isCalling = false;
  //   const phoneNumber = this.lead?.primaryPhoneNumber || 'Unknown number';
  //   alert(`Call ended with ${phoneNumber}`);
  // }
  
  onEndCall() {
    this.isCalling = false;
    const phoneNumber = this.lead?.primaryPhoneNumber;
    
    // Check if agentId and phoneNumber are both valid (non-null, non-empty)
    const id_agent = this.agentService?.getAgentIdAppareil();
    if (id_agent && phoneNumber) {
      this.agentService.endCallDataByAgent(id_agent, phoneNumber).subscribe({
        next: (response) => {
          console.log('Call ended successfully:', response);
          alert(`Call successfully ended: ${response.message}`);
        },
        error: (error) => {
          console.error('Error ending call:', error);
          alert('Failed to end the call. Please try again later.');
        },
      });
    } else {
      alert('Agent ID and Phone Number are required to end the call.');
    }
  
    // alert(`Call ended with ${phoneNumber || 'Unknown number'}`);
  }
  
  private extractDate(dateTimeString: string): string {
    if (!dateTimeString) return ''; // Return empty string if dateTimeString is null or undefined
    return dateTimeString.split('T')[0]; // Extract date part and return
  }

  onProvinceChange(event: any): void {
    const selectedProvince = event.target.value; // Get selected province from event
    console.log('Selected Province:', selectedProvince); 
    
    // Filter locations based on the selected province
    const provinceOption = this.locations.filter(location => location.province === selectedProvince);
    console.log('Filtered Province Options:', provinceOption); // Log filtered locations by province
    
    // If we have locations for the selected province, filter out cities
    if (provinceOption.length > 0) {
        this.filteredCities = provinceOption.map(location => location.city); // Get list of cities for the selected province
        console.log('Filtered Cities:', this.filteredCities); // Log filtered cities
    } else {
        this.filteredCities = []; // If no matching province, reset cities
    }

    // Optionally, clear city and zip code if no province matches
    this.leadForm.get('city')?.setValue('');
    this.leadForm.get('zipCode')?.setValue('');
}

onCitySelected(selectedCity: string): void {
  console.log('City Selected:', selectedCity); // Debugging line to check if the function is triggered

  // Find the location matching the selected city
  const matchingCity = this.locations.find(location => location.city === selectedCity);

  if (matchingCity) {
    // If a matching city is found, set the corresponding postal code (zipCode)
    this.leadForm.get('zipCode')?.setValue(matchingCity.postal_code);
    console.log('Postal Code for selected city:', matchingCity.postal_code);
  } else {
    // If no city matches, reset the zip code field
    this.leadForm.get('zipCode')?.setValue('');
    console.log('No matching city found for:', selectedCity);
  }
}

onStatusChange(event: any): void {
  const selectedStatus = event.target.value;
  console.log("the selected status is",selectedStatus);
  if (selectedStatus === "CANCELED") {
    this.showCancellationReasons = true;
  } else {
    this.showCancellationReasons = false;
  }
}

  private initializeForm(): void {

  // Check if the form is preloaded with a province value
  const provinceValue = this.convertStringForComparison(this.lead?.province);
  if (provinceValue) {
      const provinceOption = this.locations?.filter(location => location.province === provinceValue);
      if (provinceOption?.length > 0) {
          this.filteredCities = provinceOption.map(location => location.city); // Get list of cities for the selected province
          console.log('Filtered Cities:', this.filteredCities);
      } else {
          this.filteredCities = []; // Reset cities if no matching province
      }
  }
    const cityValue = this.convertStringForComparison(this.lead?.city);

    // const provinceValue = this.lead?.province ? this.lead.province.charAt(0).toUpperCase() + this.lead.province.slice(1) : '';
    // const cityValue = this.lead?.city ? this.lead.city.charAt(0).toUpperCase() + this.lead.city.slice(1) : '';

    //TODO Tunisia is static change to dynamic when more details provided from the business
    this.leadForm = this.fb.group({
      referenceNumber: [{ value: this.lead?.referenceNumber || '', disabled: true }, Validators.required],
      name: [this.lead?.name || '', Validators.required],
      shopName: [{ value: String(this.lead?.shopName), disabled: true }],
      webMaster: [{ value: this.lead?.webMaster || '', disabled: true }],
      fullAddress: [this.lead?.fullAddress || ''],
     
      country: [{ value: this.lead?.country ? String(this.lead?.country) : 'Tunisia', disabled: true }], 
      province: [provinceValue|| ''], 
      city: [cityValue || ''],
      zipCode: [this.lead?.zipCode || ''],
      primaryPhoneNumber: [this.lead?.primaryPhoneNumber || ''],
      secondaryPhoneNumber: [this.lead?.secondaryPhoneNumber || ''],
      scheduledDeliveryDate: [this.extractDate(this.lead?.scheduledDeliveryDate) || ''],


     
      upsell: [String(this.lead?.upsell)],
      offerId: [this.lead?.offerId || ''],
      offerCurrency: [this.lead?.offerCurrency || ''],
      offerValue: [this.lead?.offerValue || ''],
      offerUrl: [{ value: this.lead?.offerUrl || '', disabled: true }],
      allowedReducedPrice: [{ value: this.lead?.allowedReducedPrice || '', disabled:true}],
      // offerUrl: [this.lead?.offerUrl || ''],
      // allowedReducedPrice: [{ value: String(this.lead?.allowedReducedPrice), disabled: true }],
      
      countrycode: [{ value: this.lead?.countryCode || '', disabled: true }],
      status: [this.lead?.status || 'CONFIRMED', Validators.required],
      callCenterNotes: [''], // Add call center notes field
      cancellationReason: [this.lead?.cancellationReason || ''], // Always present, but value can be empty
      products: this.fb.array([]),

    });

    this.lead?.products.forEach(product => {
      this.addProduct(product);
    });

    this.form$ = this.leadForm.valueChanges.pipe(map(() => this.leadForm));

    const provinceOption = this.supportedCities.find(province => province.province === this.leadForm.get('province').value);
    provinceOption ? this.filteredCities = provinceOption.cities : [];
 
   
// Listen for changes in the city field
// this.leadForm.get('city')?.valueChanges.subscribe((selectedCity) => {
//   this.onCitySelected(selectedCity);
// });

// Check if a zip code is already provided and handle accordingly
if (!this.lead?.zipCode) {
  // If zip code is not provided, you can still call onCitySelected when a city is selected
  // (handled above with valueChanges subscription)
}
}

// Method to update ZIP code based on the selected city (subDivision)
// onCitySelected(selectedCity: string): void {
// // Find the postal code entry where the subDivision matches the selectedCity
// const matchingCity = postalCode.find(city => city.subDivision === selectedCity);

// // If a matching subDivision (city) is found, set its postalCode in the form
// if (matchingCity) {
//   this.leadForm.get('zipCode')?.setValue(matchingCity.postalCode);
// } else {
//   // Optionally clear the zipCode if no match is found
//   this.leadForm.get('zipCode')?.setValue('');
// }


//   }

 
  updateStatusBasedOnBackendValue(): void {
    const currentStatus = this.leadForm.get('status').value;
    if (currentStatus === 'CANCELED') {
      this.showCancellationReasons = true;
    }
    if (currentStatus === 'PENDING_CONFIRMATION') {
      this.leadForm.get('status').setValue('NEW');
    } else if (currentStatus === 'PENDING_RECONFIRMATION') {
      this.leadForm.get('status').setValue('CONFIRMED');
    }
    if (this.leadForm.get('upsell').value === "UPSOLD") { // Ensure the upsell matches the backend enum case
      this.leadForm.get('status').setValue('UPSELL'); // Automatically update status from confirmed to upsell
    }
  }
  
  // onProvinceChange($event: any): void {
  //   const selectedProvince = $event.target.value;
  //   console.log("province men form", this.leadForm.get('province').value)
  //   // Use leadProvince variable to check the province from lead
  //   const leadProvince = this.lead?.province;
  //   console.log("Lead Province !!!!:", leadProvince);
  //   // Check if the selected province is empty or null
  //   if (!selectedProvince || selectedProvince === '') {
  //     return;
  //   }

  //   // Set the selected province in the form
  //   this.leadForm.get('province')?.setValue(selectedProvince);

  //   // Check if the selected province exists in the supported cities
  //   const provinceOption = this.supportedCities.find(province => province.province === selectedProvince);
  //  console.log(provinceOption , "heeeeeyyyyy")
  //   if (provinceOption) {
  //     // Update the filtered cities based on the selected province
  //     this.filteredCities = provinceOption.cities || [];
  //   } else {
  //     // If the selected province is not found in supported cities, reset form values
  //     this.leadForm.get('province')?.setValue(null);
  //     this.leadForm.get('city')?.setValue(null);
  //     this.filteredCities = [];
  //   }
  // }

  get productsFormArray(): FormArray {
    return this.leadForm.get('products') as FormArray;
  }

  addProduct(product?: any): void {
    const isEditing = !product; // Check if a product is being edited
  
    const newProduct = this.fb.group({
        sku: [product?.sku || '', Validators.required], // Always required
        quantity: [product?.quantity || ''], // Always enabled
        value: [product?.value || ''],
        currency: [product?.currency || ''],
        description: [product?.description || ''],
        productLink: [product?.productLink || '']
    });
  
    this.productsFormArray.push(newProduct);
  
    // Add SKU to skusList if it's not already present
    if (this.skusList && product?.sku && !this.skusList.some(sku => sku.sku === product.sku)) {
      this.skusList.push(product);
    }
    console.log("heree",this.skusList)
  }
  
  onSkuSelect(index: number, selectedSku: string): void {
    const skuDetails = this.skusList.find(sku => sku.sku === selectedSku);
    
    if (skuDetails) {
      const productFormGroup = this.productsFormArray.at(index);
      productFormGroup.patchValue({
        sku: skuDetails.sku, // Update SKU field
        value: skuDetails.value || skuDetails.price || '',
        description: skuDetails.description || '',
        productLink: skuDetails.productLink || skuDetails.productImageUrl || ''
      });
    }
  }

  serializeFormData(): string {
    const formData = { ...this.lead, ...this.leadForm.value };
    return JSON.stringify(formData);
  }

  // Was Working !!!!
  // private convertStringForComparison(str: string): string {
  //   if (!str) return '';
  
  //   return str.toLowerCase().split(/[\s-]+/).map(word => {
  //     return word.replace(/(?:^|\s|'|-)\S/g, function (match) {
  //       return match.toUpperCase();
  //     });
  //   }).join(' ');
  // }

// WORKING !!!!!
  private convertStringForComparison(str: string): string {
    if (!str) return '';
    return str.toLowerCase().split(/[\s-]+/)
      .map(word => {
        const capitalizedWord = word.charAt(0).toUpperCase() + word.slice(1);
        return capitalizedWord.replace(/(?:^|\s|'|-)\S/g, function (match) {
          return match.toUpperCase();
        });
      })
      .join(' ');
  }
 
  onSubmit(): void {
    if (this.isSubmitting) return;
    this.isSubmitting = true;

      // Get the current date and time
  const currentTime = new Date();

  // Log the current time to the console
  console.log('Current Time:', currentTime);
 
    if (this.productsFormArray.length === 0) {
      this.agentService.openModal('At least one product is required. Please add a product before submitting.');
      this.isSubmitting = false;
      return; // Exit the function early if no product is added
    }
      // Check if all products have required fields filled
  const allProductsValid = this.productsFormArray.controls.every((control: FormGroup) => {
    const sku = control.get('sku').value;
    const quantity = control.get('quantity').value;
    const description = control.get('description').value;
    return sku && quantity && description; // Check if all required fields are filled
  });

  if (!allProductsValid) {
    console.error('All products must have SKU, quantity, and description filled.');
    this.agentService.openModal('All products must have SKU, quantity, and description filled.');
    this.isSubmitting = false;
    return; // Exit the function early if no product is added
   
  }
    if (this.leadForm.valid) {
      // Extract new scheduled delivery date from the form
      const newScheduledDeliveryDate: Date = this.leadForm.get('scheduledDeliveryDate').value;
      this.lead.totalCalls = (Number(this.totalCalls) + 1).toString();
      if (Number(this.lead.totalCalls) === 10) {
        console.log("total calls is 10");
        this.leadForm.get('status').setValue('CANCELED');
        this.leadForm.get('cancellationReason').setValue('Client injoignable (10 attempts)');
      }
      // Format the scheduled delivery date as a string with milliseconds and timezone information
      const formattedScheduledDeliveryDate: string = this.datePipe.transform(newScheduledDeliveryDate, 'yyyy-MM-dd\'T\'HH:mm:ss.SSS\'Z\'');
  
      // Construct the lead object including all product fields
      const leadData = {
        ...this.lead,
        ...this.leadForm.value,
        scheduledDeliveryDate: formattedScheduledDeliveryDate,
        products: this.productsFormArray.getRawValue() // Get raw values of all products including disabled fields
      };

       //Modify status and upsell fields if status is "upsell"
        if (leadData.status === "UPSELL") {
          leadData.status = "CONFIRMED";  // Send "confirmed" instead of "upsell"
          leadData.upsell = "UPSOLD";     // Set "upsell" column to "upsold"
        }
  
      // Log the serialized form data to JSON
      const formDataJson = JSON.stringify(leadData);
      console.log('Form Data JSON:', formDataJson);
      // Update lead data in the backend
      this.agentService.updateJsonData(leadData);
       // Subscribe to update status
       this.agentService.updateStatus$.subscribe((status: boolean) => {
        if (status) {
          this.agentService.openModal('Lead update is done! You will be redirected to home page now ' , status);
          // this.modal.closeModal(status);
        } else {
          this.agentService.openModal('Oops! Something went wrong. Please try again.',false);
        }
        this.isSubmitting = false;
      }); 
    } else {
      console.error('Form validation failed. Please check the form inputs.');
      this.agentService.openModal('Form validation failed. Please check the form inputs.');
      this.isSubmitting = false;
    }

    this.saveAgentHistory();
  }

  getObjectKeys(obj: any): string[] {
    return Object.keys(obj);
  }

  isArray(value: any): boolean {
    return Array.isArray(value);
  }

  isObject(value: any): boolean {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
  }

  // Logic to save data in agent history table 

  saveAgentHistory(): void {
    const endTime = new Date();
    this.duration = Math.floor((endTime.getTime() - this.startTime.getTime()) / 1000); // Calculate duration in seconds
     // Retrieve the agent ID dynamically from AgentService
     this.agentHistory.idAgent = this.agentService.getAgentId(); // Set the agent ID
     // Set Lead ID for agent history Table
     this.agentHistory.idLead = this.lead.id;
    //  this.agentHistory.fbleadreference = this.lead.fbLeadReference;
    // Update the agentHistory object with the calculated duration and actionDate
    this.agentHistory.duration = this.duration; // Set duration in second
    const selectedStatus = this.leadForm.get('status').value;  // Access the status value from the form control
    this.agentHistory.actionStatus = selectedStatus;  // Pass the status to agentHistory
    // Call the service to save the agent history
    this.agentService.saveAgentHistory(this.agentHistory).subscribe(
      response => {
        console.log('Agent history saved successfully:', response);
      },
      error => {
        console.error('Error saving agent history:', error);
      }
    );
  }

  // 1. This method triggers when the user is about to leave the page (e.g., refresh, close tab)
  @HostListener('window:beforeunload', ['$event'])
  beforeUnloadHandler(event: Event) {
    this.releaseLead(); // Call the method to release the lead
  }

  ngOnDestroy(): void {
    this.leadSocket.close()
    // Clear the interval when the component is destroyed
    clearInterval(this.intervalId);
    this.releaseLead();
  }

  fetchLocations(countries: string[]): void {
    this.agentService.getLocationsByCountries(countries).subscribe(data => {
      // Check data structure and filter out any empty locations arrays
      console.log("API Response Data:", data); 
  
      // Flatten the locations list and assign it to 'locations'
      this.locations = data
        .map((response: any) => response.locations || []) // Ensure locations exists
        .flat();  // Flatten the array of location arrays into a single array
      
      console.log('Flattened Locations:', this.locations); // Check if locations are correctly flattened
  
      // Extract unique provinces using Set
      this.supportedCities = Array.from(new Set(this.locations.map(location => location.province)));
  
      console.log('Supported Cities:', this.supportedCities);
    });
  }
    

// Method to release the lead
releaseLead() {
  if (this.leadReferenceFromUrl) {
    this.agentService.releaseLead(this.leadReferenceFromUrl).subscribe({
      next: () => console.log('Lead released'),
      error: (err) => console.error('Failed to release lead', err),
    });
  }
}
// Method to skip the lead
// onSkip() {
//   if (!this.lead?.fbLeadReference) {
//     console.warn('No FBLeadReference found for skipping');
//     return;
//   }
//   console.log('Skip button clicked for lead:', this.lead.fbLeadReference);
//   this.agentService.skipLead(this.lead.fbLeadReference).subscribe({
//     next: () => console.log(`Successfully skipped lead: ${this.lead.fbLeadReference}`),
//     error: (err) => console.error('Error skipping lead:', err),
//   });
// }

// onSkip() {
//   if (!this.lead?.fbLeadReference) {
//     console.warn('No FBLeadReference found for skipping');
//     return;
//   }

//   console.log('Skip button clicked for lead:', this.lead.fbLeadReference);

//   // First, skip the lead
//   this.agentService.skipLead(this.lead.fbLeadReference).subscribe({
//     next: () => {
//       console.log(`Successfully skipped lead: ${this.lead.fbLeadReference}`);

//       // After skipping the lead, retrieve parameters from sessionStorage
//       const selectedCountries = JSON.parse(sessionStorage.getItem('selectedCountries') || '[]');
//       const selectedStatuses = JSON.parse(sessionStorage.getItem('selectedStatuses') || '[]');
//       const selectedCompanyIds = JSON.parse(sessionStorage.getItem('selectedCompanyIds') || '[]');
//       const daysRangeToBackend = sessionStorage.getItem('daysAgo') ? Number(sessionStorage.getItem('daysAgo')) : null;
//       if (selectedStatuses.includes("NEW")) {
//         selectedStatuses.push("PENDING_CONFIRMATION");
//       }
//       const selectedCountryCodes = selectedCountries.map(country => this.countryCodeMap[country]);
//       console.log('Retrieved from sessionStorage:');
//       console.log('Selected Countries:', selectedCountries);
//       console.log('Selected Statuses:', selectedStatuses);
//       console.log('Selected Company IDs:', selectedCompanyIds);
//       console.log('Days Range to Backend:', daysRangeToBackend);

//       // Call getNextLead with the retrieved session storage values
//       this.agentService.getNextLead(selectedCountryCodes, selectedStatuses, selectedCompanyIds, daysRangeToBackend).subscribe({
//         next: (nextLeadReference) => {
//           console.log('Next lead received:', nextLeadReference);
//           // Handle the next lead here, maybe update the UI or do something with it
//         },
//         error: (err) => {
//           console.error('Error fetching next lead:', err);
//         }
//       });
//     },
//     error: (err) => {
//       console.error('Error skipping lead:', err);
//     }
//   });
// }
onSkip() {
  if (!this.lead?.fbLeadReference) {
    console.warn('No FBLeadReference found for skipping');
    return;
  }

  console.log('Skip button clicked for lead:', this.lead.fbLeadReference);
  this.releaseLead();
  // First, skip the lead
  this.agentService.skipLead(this.lead.fbLeadReference).subscribe({
    next: () => {
      console.log(`Successfully skipped lead: ${this.lead.fbLeadReference}`);

      // Retrieve filter parameters from sessionStorage
      const selectedCountries = JSON.parse(sessionStorage.getItem('selectedCountries') || '[]');
      let selectedStatuses = JSON.parse(sessionStorage.getItem('selectedStatuses') || '[]');
      const selectedCompanyIds = JSON.parse(sessionStorage.getItem('selectedCompanies') || '[]');
      const daysRangeToBackend = sessionStorage.getItem('daysAgo') ? Number(sessionStorage.getItem('daysAgo')) : null;

      // If "NEW" status exists, also add "PENDING_CONFIRMATION"
      if (selectedStatuses.includes("NEW") && !selectedStatuses.includes("PENDING_CONFIRMATION")) {
        selectedStatuses.push("PENDING_CONFIRMATION");
      }

      // Convert country names to country codes
      const selectedCountryCodes = selectedCountries.map(country => this.countryCodeMap[country]);

      // Debugging logs
      console.log('Retrieved from sessionStorage:');
      console.log('Selected Countries:', selectedCountries);
      console.log('Selected Statuses:', selectedStatuses);
      console.log('Selected Company IDs for the skip button:', selectedCompanyIds);
      const companyIdsFromTheList = selectedCompanyIds ? selectedCompanyIds.map(company => company.id) : [];
      console.log('Clean Company IDs for the skip button:', companyIdsFromTheList);
      console.log('Days Range to Backend:', daysRangeToBackend);

      // Call getNextLead with the retrieved session storage values
      this.agentService.getNextLead(selectedCountryCodes, selectedStatuses, companyIdsFromTheList, daysRangeToBackend).subscribe({
        next: (nextLeadReference) => {
          console.log('Next lead received:', nextLeadReference);

          if (nextLeadReference && nextLeadReference !== 'No leads available for now refresh later') {
            console.log('Lead data received:', nextLeadReference);

            // Construct the URL using the received lead reference
            const url = `/agent/editlead?leadreference=${nextLeadReference}`;

            // Navigate to the constructed URL
            console.log("Navigating to URL:", url);
            this.router.navigateByUrl(url);
            this.leadSocket.connect();
          } else {
            // Stay on the current page and alert the user
            console.warn('No leads available.');
            alert('No leads available for now, please refresh later.');
          }
        },
        error: (err) => {
          console.error('Error fetching next lead:', err);
        }
      });
    },
    error: (err) => {
      console.error('Error skipping lead:', err);
    }
  });
}

// isNewStatus(): boolean {
//   // Safely retrieve and parse the sessionStorage item
//   const selectedStatuses = sessionStorage.getItem('selectedStatuses');
//   if (selectedStatuses) {
//     const statuses = JSON.parse(selectedStatuses);
//     return statuses.includes('NEW');
//   }
//   console.log("yooooo",selectedStatuses);
//   return false; // If no status or no "NEW" found, return false
// }

isNewStatus(): boolean {
  const selectedStatuses = sessionStorage.getItem('selectedStatuses');
  
  // If selectedStatuses is not available or is null, return true
  if (!selectedStatuses) {
    this.newStatus = true;
    return this.newStatus;
  }

  // Parse the statuses from sessionStorage
  const statuses = JSON.parse(selectedStatuses);

  // If 'NEW' is in the statuses or if selectedStatuses is empty, set newStatus to true
  this.newStatus = statuses.includes('NEW') || statuses.length === 0;

  return this.newStatus;
}



}